import { motion } from "framer-motion";

const ERRORS = [
  "Sabes lo que tienes que hacer… pero no lo haces.",
  "Empiezas con fuerza… y vuelves al mismo punto.",
  "Te prometes cambiar… y repites el mismo patrón.",
  "Vives en automático, con ansiedad de fondo.",
  "Tomas decisiones que tu yo de mañana lamenta.",
];

export default function Problem() {
  return (
    <section
      id="problema"
      data-testid="problem-section"
      className="surface-light relative py-24 sm:py-32"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16">
          <div className="lg:col-span-5">
            <div className="flex items-center gap-3 mb-8">
              <span className="h-px w-10 bg-taupe/60" />
              <span className="font-body text-[11px] tracking-[0.28em] uppercase text-taupe">
                01 · Diagnóstico
              </span>
            </div>
            <motion.h2
              initial={{ opacity: 0, y: 18 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-100px" }}
              transition={{ duration: 0.7 }}
              data-testid="problem-headline"
              className="font-display text-4xl sm:text-5xl lg:text-6xl font-normal tracking-[-0.02em] leading-[1.0] text-ink"
            >
              No es falta
              <br />
              de disciplina.
              <br />
              <em className="italic text-taupe">Es programación.</em>
            </motion.h2>
            <p className="mt-8 font-body text-base sm:text-lg text-[#3A342D] leading-relaxed max-w-md">
              Una programación que se ha instalado durante toda tu vida y dirige tus decisiones en
              automático. Mientras no la cambies, tu vida seguirá repitiéndose.
            </p>
          </div>

          <div className="lg:col-span-7">
            <ul className="divide-y divide-[#E1DAD0]">
              {ERRORS.map((e, i) => (
                <motion.li
                  key={i}
                  initial={{ opacity: 0, x: 8 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  viewport={{ once: true }}
                  transition={{ delay: i * 0.08, duration: 0.5 }}
                  data-testid={`problem-error-${i}`}
                  className="group flex items-start gap-6 py-6 hover:bg-[#F7F4EF]/60 -mx-3 px-3 rounded-lg transition-colors"
                >
                  <span className="font-mono text-[11px] tracking-[0.18em] text-warm pt-2 shrink-0">
                    {String(i + 1).padStart(2, "0")}
                  </span>
                  <span className="font-display text-2xl sm:text-3xl text-ink leading-snug">
                    {e}
                  </span>
                </motion.li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}
